import { AloftDate, AloftPrice, MILES_TO_METERS, SubjectData } from '@aloft/toolkit-shared';

import { getLocationTypeProximityRequirementMiles } from '../../../utils/locationTypeProximityRequirementMiles.ts';
import { getLocationTypeSaleDateRequirementMonths } from '../../../utils/locationTypeSaleDateRequirementMonths.ts';
import { InitialCompSearch } from '../types.ts';

export const DEFAULT_RECOMMENDED_COMP_PROPERTY_SUB_TYPE = 'Single Family Residence';

const DEFAULT_GLA_VARIANCE_PCT = 20;
const DEFAULT_YEAR_BUILT_VARIANCE_YEARS = 10;
const DEFAULT_SALE_PRICE_MIN = 10000;

export const getDefaultRecommendedCompSearch = (
  subject: SubjectData,
  _effectiveDate: AloftDate,
): InitialCompSearch['body']['search'] => {
  const locationType = subject.editableData.propertyIdentification.locationType;
  const proximityRequirementMiles = getLocationTypeProximityRequirementMiles(locationType);
  const saleDateRequirementMonths = getLocationTypeSaleDateRequirementMonths(locationType) ?? 12;
  const coordinates = subject.editableData.propertyIdentification.coordinates;

  return {
    filters: {
      status: '',
      propertySubType: DEFAULT_RECOMMENDED_COMP_PROPERTY_SUB_TYPE,
      saleDate: {
        variance: saleDateRequirementMonths,
      },
      salePrice: {
        min: AloftPrice.fromDollarLike(DEFAULT_SALE_PRICE_MIN),
        max: undefined,
      },
      gla: {
        percentage: DEFAULT_GLA_VARIANCE_PCT,
      },
      lotSize: {
        percentage: '',
      },
      yearBuilt: {
        variance: DEFAULT_YEAR_BUILT_VARIANCE_YEARS,
      },
      bedrooms: {
        variance: '',
      },
      fullBaths: {
        variance: '',
      },
      halfBaths: {},
      stories: {
        variance: '',
      },
      garageSpaces: {},
    },
    geoSearch: {
      t: 'radius',
      radiusInMeters: (proximityRequirementMiles ?? 1) * MILES_TO_METERS,
      coord: [coordinates?.longitude ?? 0, coordinates?.latitude ?? 0],
    },
    matchCriteria: {
      saleDate: 'lasting_range',
      salePrice: 'min_max_range',
      gla: 'percentage_range',
      lotSize: 'percentage_range',
      yearBuilt: 'value_range',
      bedrooms: 'value_range',
      fullBaths: 'value_range',
      halfBaths: 'min_max_range',
      stories: 'value_range',
      garageSpaces: 'min_max_range',
    },
  } as unknown as InitialCompSearch['body']['search'];
};
